import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";
import { Cookies } from "react-cookie";

export const fetchWhitelistUsers = createAsyncThunk(
  "whitelist/fetchUsers",
  async ({ is_registered }, { rejectWithValue }) => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");
      const id = cookies.get("societyId");

      const response = await AxiosInstance.get(
        `${API_KEY}/api/whitelist/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            is_registered,
          },
        }
      );

      return response;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const initialState = {
  isLoading: false,
  userListData: [],
  isError: false,
  errorMessage: "",
};

const whitelistUsersSlice = createSlice({
  name: "whitelistUsers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWhitelistUsers.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(fetchWhitelistUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.userList = action.payload;
      })
      .addCase(fetchWhitelistUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload || "Failed to fetch user list.";
      });
  },
});

export default whitelistUsersSlice.reducer;
